module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Marlborough Buildings",
    url: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    holding: {
        "brand": "https://marlboroughbuilding.info/assets/images/favicon/favicon-32x32.png",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "",
        "contact_number": "",
        "contact_email": ""
    },

    meta: {
        "defaultSocialImage": "https://marlboroughbuilding.info//assets/images/favicon/favicon-32x32.png",
        "author": "",
        "description": "",
        "gtag": "G-P5B35F0DFG",
        "gtm": "GTM-52NC4S6"
    },

    form: {
        "contact": {
            "catcher_id": "a29e58dc278f1c9501dbdc7116a9e7d8",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "b701b3fe5420146fffdf222a4ad7d4de"
        },
        "feedback": {
            "catcher_id": "e01c563cb3eff6c0655ed45252ac90c7",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "eddf5ae75a0cfe79c4f9cbf54f4b9e3b"
        }
    },

    consultation: {   
        "feedback_active": true, 
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",
        
        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": true,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "First theme",
                "url": "section-1",
                "feedback_url": '',
                "icon": "drainage_strategy",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "01-section"
            },
            {
                "name": "Second theme",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "heritage",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "02-section"
            },
            {
                "name": "Third theme",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "environment",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "03-section"
            },
            {
                "name": "Fourth theme",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "leisure_and_recreation",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "04-section"
            },
            {
                "name": "Fifth theme",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "highways_and_transport",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "05-section"
            },
            {
                "name": "Sixth theme",
                "url": "section-6",
                "feedback_url": 'page-6/',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "06-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Latest revised proposals <br> Information panels shown at drop-in session (16.5.24) <br> <br>2023 planning application proposals",
            "url": "/assets/images/downloads/Marlborough-House-Community-Engagement-boards-HR.pdf"
        },
        {
            "title": "Presentation shown at webinar (18.04.23)",
            "url": "/assets/images/downloads/Marlborough-House-Webinar-Presentation.pdf"
        },
        {
            "title": "Watch the webinar presentation (18.04.23)",
            "videoId": "819535829",
            "type": "video"
        },
        {
            "title": "Information panels shown at drop-in session (19.04.23)",
            "url": "/assets/images/downloads/Marlborough-drop-in-session-boards.pdf"
        }
    ],
    
    faqs: [
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: '',

    // Marker.io Key - replace this default key
    marker_io: '618d2de7be76ee21e8452764'
};